export default __webpack_public_path__ + "media/images/features/hida/map-48f1655a701a45987aeba7ae8863c53f.png";